// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"191":"fea14be6a8b04e6d","8954":"97face63e57293b7"}[chunkId] + ".css";
};